import { pluck, pathOr } from 'ramda'
import { VIDEO_SIDE_MARGIN, VIDEO_MAX_WIDTH } from '../constants'

export const getWidestVideoRatio = works => Math.min(...pluck('videoRatio', works))

export const getMaxWidth = (width, maxWidth) => (width < maxWidth ? width : maxWidth)

export const getMaxHeight = (height, maxHeight) => (height < maxHeight ? height : maxHeight)

export const getHeightFromWidestVideo = (width, ratio, maxHeight) => {
  const widthMinusMargins = width - (VIDEO_SIDE_MARGIN * 2)
  const newWidth = getMaxWidth(widthMinusMargins, VIDEO_MAX_WIDTH)
  const height = newWidth * (ratio / 100)
  return getMaxHeight(height, maxHeight)
}

export const getWidthFromHeight = (height, ratio) => height / (ratio * 0.01)

export const getImageUrlPrefix = (folderName, isThumb = false) => {
  const origin = process.env.NODE_ENV === 'production'
    ? window.location.origin
    : 'http://localhost:8083'

  if (isThumb) {
    return `${origin}/uploads/${folderName}/thumbs/`
  }
  return `${origin}/uploads/${folderName}/`
}

export const getThumbUrlPrefix = folderName => getImageUrlPrefix(folderName, true)

export const handleFirstLoad = (firstSlug) => {
  const pathname = pathOr('/', ['location', 'pathname'], window)
  const match = pathname === '/' || pathname === '/works' || pathname === '/works/'
  const url = `/works/${firstSlug}`

  if (match) {
    if (window.history.replaceState) {
      window.history.replaceState({}, '', url)
    } else {
      window.location = url
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/index.js